import React, { useState, useEffect } from "react";
import Icon from "../../components/ui/icon";
import "../../assets/styles/pages/publishers/campaignDetail.css";
import SideNav from "../../components/layout/sideNav";
import { useToast } from "../../context/toastContext";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../services/apiClient";
import DOMPurify from "dompurify";
import { convertCurrency } from "../../utils/currencyConverter";
import { storageManager } from "../../utils/storageManager";
import countryOptions from "../../utils/countryOptions";

const CampaignDetailPage = () => {
  const navigate = useNavigate();
  const showToast = useToast();
  const [isSideNavActive, setisSideNavActive] = useState(false);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("PublisherInfo")) || {}
  );
  const [campInfo, setcampInfo] = useState({});
  const [campInfoLoading, setcampInfoLoading] = useState(true);
  const [trackLink, setTrackLink] = useState(`Preparing...`);
  const [isPostbackAddWindowActive, setIsPostbackAddWindowActive] =
    useState(false);
  const [takingAction, setTakingAction] = useState(null);
  const { campID } = useParams();
  const [isPostbackSaveBtnDisabled, setIsPostbackSaveBtnDisabled] =
    useState(false);
  const [goalInput, setGoalInput] = useState("");
  const [pbURLInput, setpbURLInput] = useState("");
  const [isPostbackViewerActive, setisPostbackViewerActive] = useState(false);
  const [toViewPBInfo, settoViewPBInfo] = useState({
    goalName: "",
    URL: "",
  });
  const [selectedDomain, setSelectedDomain] = useState(window.location.host);
  const [isDeletingPostback, setisDeletingPostback] = useState(false);
  const [optionWindowActive, setOptionWindowActive] = useState(false);
  const currency = storageManager.getCurrency();
  const trackingParams = [
    "aff_click_id",
    "sub_aff_id",
    "source",
    "gaid",
    "sub2",
    "sub3",
    "sub4",
    "sub5",
    "sub6",
    "sub7",
    "sub8",
  ];

  useEffect(() => {
    const token = localStorage.getItem("aToken");
    if (!token) {
      navigate("/auth/login");
      return;
    }

    api
      .get(`/api/publisher/info`)
      .then((response) => {
        setUserInfo(response.data.data);
        localStorage.setItem(
          "PublisherInfo",
          JSON.stringify(response.data.data)
        );
        const pubID = response.data.data.publisherId;
        api
          .get(`/api/campaign/${campID}`)
          .then((response) => {
            setcampInfo(response.data.campaign);
            setTrackLink(
              `track/?pubID=${pubID}&campID=${response.data.campaign.campID}&aff_click_id={aff_click_id}&sub_aff_id={sub_aff_id}&source={source}`
            );
            setcampInfoLoading(false);
          })
          .catch((err) => {
            showToast({
              status: "error",
              message: err.response?.data?.message || "Something went wrong.",
            });
            navigate("/campaigns");
          });
      })
      .catch((err) => {
        showToast({
          status: "error",
          message: err.response?.data?.message || "Login not found.",
        });
        navigate("/auth/login");
      });
  }, [campID, navigate, showToast]);

  const sanitizeInput = (value) => DOMPurify.sanitize(value);

  const viewPostback = (goalName, URL) => {
    settoViewPBInfo({ goalName, URL });
    setisPostbackViewerActive(true);
  };

  const handelPostbackViewerCloseClick = () => {
    if (isDeletingPostback) return;
    setisPostbackViewerActive(false);
  };

  const handelPostbackSave = () => {
    if (isPostbackSaveBtnDisabled);
    setIsPostbackSaveBtnDisabled(true);

    const sanitizedGoal = sanitizeInput(goalInput);
    const sanitizedPostbackURL = sanitizeInput(pbURLInput);

    if (sanitizedGoal) {
      let isGoalValid = false;
      campInfo?.goals.length > 0 &&
        campInfo.goals.forEach((goal) => {
          if (goal.goalName === sanitizedGoal) {
            isGoalValid = true;
          }
        });
      if (!isGoalValid) {
        showToast({
          status: "error",
          message: "Invalid Goal Name",
        });
        setIsPostbackSaveBtnDisabled(false);
        return;
      }
    } else {
      document.getElementById("goal").focus();
      setIsPostbackSaveBtnDisabled(false);
      return;
    }

    if (!/^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w\-./?%&=:{}]*)?$/.test(sanitizedPostbackURL)) {
      showToast({
        status: "error",
        message: "Invalid URL",
      });
      setIsPostbackSaveBtnDisabled(false);
      return;
    }

    api
      .post("/api/campaign/add-postback", {
        campaignId: campID,
        goalName: sanitizedGoal,
        URL: sanitizedPostbackURL,
      })
      .then((response) => {
        const fixedMessage = response.data.status
          ? "Saved Successfully."
          : "Something went wrong.";
        showToast({
          status: response.data.status ? "success" : "error",
          message: response.data.message || fixedMessage,
        });
        setIsPostbackSaveBtnDisabled(false);
        setIsPostbackAddWindowActive(false);
        setGoalInput("");
        setpbURLInput("");
      })
      .catch((err) => {
        showToast({
          status: "error",
          message: err.response?.data?.message || "Something went wrong.",
        });
        setIsPostbackSaveBtnDisabled(false);
      });
  };

  const handelPostbackDeleteBtn = () => {
    if (isDeletingPostback) return;
    setisDeletingPostback(true);

    const sanitizedGoal = sanitizeInput(toViewPBInfo.goalName);

    if (sanitizedGoal) {
      let isGoalValid = false;
      campInfo?.goals.length > 0 &&
        campInfo.goals.forEach((goal) => {
          if (goal.goalName === sanitizedGoal) {
            isGoalValid = true;
          }
        });
      if (!isGoalValid) {
        showToast({
          status: "error",
          message: "Invalid Goal Name",
        });
        setisDeletingPostback(false);
        return;
      }
    } else {
      showToast({
        status: "error",
        message: "Invalid Goal Name",
      });
      setisDeletingPostback(false);
      return;
    }

    api
      .delete(`/api/campaign/delete-postback/${campID}/${sanitizedGoal}`)
      .then((response) => {
        const fixedMessage = response.data.status
          ? "Deleted Successfully."
          : "Something went wrong.";
        showToast({
          status: response.data.status ? "success" : "error",
          message: response.data.message || fixedMessage,
        });
        setisDeletingPostback(false);
        if (response.status) {
          setisPostbackViewerActive(false);
          setcampInfo((prevInfo) => ({
            ...prevInfo,
            postbacks: prevInfo.postbacks.filter(
              (postback) => postback.goalName !== sanitizedGoal
            ),
          }));
        }
      })
      .catch((err) => {
        console.log(err.response.data);
        showToast({
          status: "error",
          message: err.response?.data?.message || "Something went wrong.",
        });
        setisDeletingPostback(false);
      });
  };

  const handelCopyTrackingLink = (tLink) => {
    if (!trackLink || trackLink === "Preparing...") return;
    navigator.clipboard.writeText(tLink);
    showToast({
      status: "success",
      message: "Copied to clipboard.",
    });
  }

  const toggleParam = (param) => {
    if (!trackLink || trackLink === "Preparing...") return;

    try {
      let [base, query = ""] = trackLink.split("?");
      let paramsArray = query ? query.split("&") : [];

      const paramIndex = paramsArray.findIndex((p) => p.startsWith(param + "="));

      if (paramIndex > -1) {
        paramsArray.splice(paramIndex, 1);
      } else {
        paramsArray.push(`${param}={${param}}`);
      }

      const newLink = paramsArray.length > 0 ? `${base}?${paramsArray.join("&")}` : base;
      setTrackLink(newLink);
    } catch (err) {
      alert("Invalid URL format!");
    }
  };

  const getName = (value) => {
    const item = countryOptions.find(c => c.value === value);
    return item ? `${item.value}` : value;
  };

  const handleActionButton = (campaign) => {
    if (takingAction) return;

    if (campaign.isUserJoined && campaign.isApproved) {
      return;
    }

    if (["pending", "rejected"].includes(campaign.approvalStatus)) return;

    setTakingAction(true);

    api
      .post("/api/campaign/join-campaign", { campaignId: campaign.campID })
      .then((response) => {
        setTakingAction(null);
        const { message } = response.data;

        if (message === "You have successfully joined this campaign") {
          setcampInfo((c) => ({
            ...c,
            isUserJoined: true,
            isApproved: true,
            approvalStatus: "approved",
          }));
        } else if (response.data?.pending) {
          setcampInfo((c) => ({
            ...c,
            approvalStatus: "pending",
          }));
        }
      })
      .catch((err) => {
        setTakingAction(null);
        showToast({
          status: "error",
          message: err.response?.data?.message || "Something went wrong.",
        });
      });
  };

  return (
    <div className="cdetails__page">
      <SideNav
        userName={userInfo.name}
        emailID={userInfo.email}
        active={isSideNavActive}
        campaignOpenInital={false}
        accManagerName={userInfo.adminInfo?.name}
        accManagerEmail={userInfo.adminInfo?.email}
      />
      <div
        onClick={() => setisSideNavActive(!isSideNavActive)}
        className={
          isSideNavActive ? "background-shadow active" : "background-shadow"
        }
      ></div>
      <main>
        <header className="desktop-header">
          <div>
            <h2>Campaign Details - Swift Digital Ads</h2>
            <p>Know everything about the campaign.</p>
          </div>
          <button
            onClick={() =>
              navigate(`/reports`, {
                state: { campName: campInfo.name, id: campID },
              })
            }
          >
            See Reports
            <Icon name="ChevronRight" className="onRight" />
          </button>
        </header>

        <header className="mobile-header">
          <div>
            <h2>Details</h2>
          </div>
          <button
            className="nav-btn"
            onClick={() => setisSideNavActive(!isSideNavActive)}
          >
            {isSideNavActive ? (
              <Icon name="XMark" className="onLeft" />
            ) : (
              <Icon name="Bars3" className="onLeft" />
            )}
          </button>
        </header>

        {!campInfoLoading &&
          campInfo &&
          !(campInfo.isUserJoined && campInfo.isApproved) && (
            <div
              className={`top-message ${campInfo.approvalStatus === "rejected"
                ? "red"
                : campInfo.approvalStatus === "pending"
                  ? "yellow"
                  : "green"
                } ${!(campInfo.isUserJoined && campInfo.isApproved) && (campInfo?.approvalStatus === null || campInfo?.approvalStatus === undefined || campInfo?.approvalStatus === "") ? "req" : ""}`}
            >
              {campInfo.approvalStatus === "pending" ? (
                <>
                  <span>Access request pending approval</span>
                  <Icon name="Clock" />
                </>
              ) : campInfo.approvalStatus === "rejected" ? (
                <>
                  <span>Access request rejected</span>
                  <Icon name="XCircle" />
                </>
              ) : (
                <>
                  <span>You are not allowed to run this campaign</span>
                  <button onClick={() => handleActionButton(campInfo)} disabled={takingAction}>
                    {takingAction && <Icon name="ArrowPath" className={"spin"} />}
                    Request Access
                  </button>
                </>
              )}
            </div>
          )}

        <div className="main-container">
          <div className="campaing-infos">
            <div className="basic-info">
              <img
                src={`${campInfoLoading
                  ? "../../DefaultImage.png"
                  : campInfo.logo
                    ? campInfo.logo
                    : "../../DefaultImage.png"
                  }`}
                alt="app/web logo"
              />
              <div>
                <span>{campInfo.name || "Loading..."}</span>
                <span>{campInfo.category || "Loading..."}</span>
              </div>
            </div>
            <div className="more-infos">
              <div className="info">
                <span>Campaing ID</span>
                <span className={campInfoLoading ? "loading" : ""}>
                  {campInfo.campID || "Loading..."}
                </span>
              </div>
              <div className="info">
                <span>Payout</span>
                <span className={campInfoLoading ? "loading" : ""}>
                  {campInfo?.goals
                    ?.filter((goal) => goal.isMain === true)
                    ?.map((goal) =>
                      convertCurrency(goal.value, goal.currency, currency)
                    )
                    ?.join(", ") || "Loading..."}
                </span>
              </div>
              <div className="info">
                <span>Status</span>
                <span className={campInfoLoading ? "loading" : ""}>
                  {campInfo.status === "active"
                    ? "Live"
                    : "Paused" || "Loading..."}
                </span>
              </div>
              <div className="info">
                <span>Preview</span>
                <span className={campInfoLoading ? "loading" : ""}>
                  {campInfo.previewLink === "" || campInfo.previewLink === null || campInfo.previewLink === undefined
                    ? "Not Avilable"
                    : <a style={{ cursor: "pointer", textDecoration: "none", color: "#0D977C" }} href={campInfo.previewLink} target="_blank" rel="noreferrer">Click Here</a>}
                </span>
              </div>
              <div className="info">
                <span>Type</span>
                <span className={campInfoLoading ? "loading" : ""}>
                  {campInfo.type || "Loading..."}
                </span>
              </div>
              <div className="info">
                <span>OS</span>
                <span className={campInfoLoading ? "loading" : ""}>
                  {
                    campInfo?.allowed_os ? campInfo.allowed_os.map((os, i) => {
                      return os + (i !== campInfo.allowed_os.length - 1 ? ", " : "");
                    }) : "Loading"
                  }
                </span>
              </div>
              <div className="locations">
                <span>Allowed Locations:</span>
                <p>{campInfoLoading
                  ? "Loading"
                  : campInfo?.allowed_locations?.length
                    ? campInfo.allowed_locations.map(getName).join(", ")
                    : "All Countries"}
                </p>
              </div>
              <div className="description">
                <span>Description:</span>
                <p style={{ whiteSpace: "pre-wrap" }}>{campInfoLoading ? "Fetching Description." : (campInfo.description ? campInfo.description : "No description provided")}</p>
              </div>
            </div>
          </div>
          <div className="other-infos-contaniner">
            <div className="goals-container">
              <h2>Goals</h2>
              <div className="small-table">
                <div className="top-sec">
                  <div>Name</div>
                  <div>Objective</div>
                  <div>Payout</div>
                </div>
                {campInfoLoading && (
                  <>
                    <div className="data loading"></div>
                    <div className="data loading"></div>
                  </>
                )}
                {campInfo.goals &&
                  campInfo.goals.length > 0 &&
                  campInfo.goals.map((goal, index) => {
                    return (
                      <div className="data" key={goal.goalName}>
                        <div>{goal.goalName}</div>
                        <div>{goal.objective || "CPR"}</div>
                        <div>
                          {convertCurrency(goal.value, goal.currency, currency)}
                        </div>
                      </div>
                    );
                  })}
              </div>
              {userInfo.cboAllowed && campInfo.cbOfferID && (
                <div className="co-container">
                  <h2>Cashback Offer</h2>
                  <div className="inp-box">
                    <label htmlFor="user-link">User Link</label>
                    <input
                      type="url"
                      id="user-link"
                      value={`http://example.com/money?id=${campInfo.cbOfferID}`}
                      readOnly
                    />
                  </div>
                  <div className="inp-box">
                    <label htmlFor="refer-link">Refer Link</label>
                    <input
                      type="url"
                      id="refer-link"
                      value={`http://example.com/money?id=${campInfo.cbOfferID}`}
                      readOnly
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="postback-container">
              <div className="top-sec">
                <h2>Postback</h2>
                <button
                  onClick={() => setIsPostbackAddWindowActive(true)}
                  disabled={campInfoLoading || !campInfo?.isApproved}
                >
                  Add
                </button>
              </div>
              <div className="small-table">
                <div className="top-sec">
                  <div>Goal</div>
                  <div>Status</div>
                  <div>URL</div>
                </div>
                {campInfoLoading && (
                  <>
                    <div className="data loading"></div>
                    <div className="data loading"></div>
                  </>
                )}
                {campInfo.postbacks && campInfo.postbacks.length > 0
                  ? campInfo.postbacks.map((postback, index) => {
                    return (
                      <div className="data" key={postback.goalName}>
                        <div>{postback.goalName}</div>
                        <div>{postback.status}</div>
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            viewPostback(postback.goalName, postback.URL)
                          }
                        >
                          View
                        </div>
                      </div>
                    );
                  })
                  : !campInfoLoading && (
                    <div className="data">
                      <span>There's no postback set.</span>
                    </div>
                  )}
              </div>
              <span className="sinfo">
                <Icon name="InformationCircle" /> Global Postback will not get
                hit when a postback is present for any campaign seapratly.
              </span>
            </div>
            <div className="tracking-link-container">
              <h2>Tracking Link</h2>

              {/* Domain Selector */}
              <div className="domain-selector">
                <label>Select Domain</label>
                <div className="domain-options">
                  {[window.location.host, "aerthads.in", "gogomedia.in"].map((domain) => (
                    <span
                      key={domain}
                      onClick={() => setSelectedDomain(domain)}
                      className={selectedDomain === domain ? "active" : ""}
                    >
                      {domain}
                    </span>
                  ))}
                </div>
              </div>

              {/* Final Tracking Link */}
              <textarea
                id="trackingLink"
                value={
                  trackLink === "Preparing..."
                    ? trackLink
                    : `https://${selectedDomain}/${trackLink}`
                }
                readOnly
              ></textarea>

              <button
                disabled={trackLink === "Preparing..."}
                onClick={() =>
                  handelCopyTrackingLink(`https://${selectedDomain}/${trackLink}`)
                }
              >
                Copy URL
              </button>

              <h3>Tracking Paramaters</h3>
              <div className="paramaters">
                {trackingParams.map((param) => {
                  const isActive = trackLink.includes(`${param}=`);
                  return (
                    <span
                      key={param}
                      onClick={() => toggleParam(param)}
                      className={isActive ? "active" : ""}
                    >
                      {param}
                    </span>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <div
          className={`background-shadow above-side-nav ${isPostbackAddWindowActive || isPostbackViewerActive ? "active" : ""
            }`}
        ></div>
        <div
          className={`postback-add-window ${isPostbackAddWindowActive ? "active" : ""
            }`}
        >
          <div className="top">
            <div>
              <h3>Add Postback</h3>
              <p>Add postback for specific goals.</p>
            </div>
            <div
              className="icon-container"
              onClick={() => setIsPostbackAddWindowActive(false)}
            >
              <Icon name="XMark" />
            </div>
          </div>

          <div className="form-container">
            <div className="inp-box">
              <label htmlFor="goal">Goal</label>
              <div className="inp-with-icon">
                <input
                  id="goal"
                  type="text"
                  placeholder="Select Goal"
                  autoComplete="off"
                  value={goalInput}
                  readOnly
                  onClick={() =>
                    setOptionWindowActive(
                      optionWindowActive === "type" ? null : "type"
                    )
                  }
                />
                <Icon name="ChevronDown" />
              </div>

              <div
                className={`selection-container ${optionWindowActive === "type" ? "active" : ""
                  }`}
              >
                <div className="notch"></div>
                {campInfo.goals &&
                  campInfo.goals.length > 0 &&
                  campInfo.goals.map((goal) => {
                    return (
                      <div
                        key={goal.goalName}
                        className={`selection-box ${goal.goalName === goalInput ? "active" : ""
                          }`}
                        onClick={() => {
                          setGoalInput(sanitizeInput(goal.goalName));
                          setOptionWindowActive(false);
                        }}
                      >
                        <span>{goal.goalName}</span>
                        <Icon name="Check" />
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className="inp-box">
              <label htmlFor="url">URL</label>
              <input
                id="url"
                type="url"
                placeholder="Enter postback url here."
                autoComplete="off"
                value={pbURLInput}
                onChange={(e) => setpbURLInput(sanitizeInput(e.target.value))}
              />
            </div>
            <button
              onClick={handelPostbackSave}
              disabled={isPostbackSaveBtnDisabled}
            >
              {isPostbackSaveBtnDisabled ? "Saving" : "Save"}
              {isPostbackSaveBtnDisabled ? (
                <Icon name="ArrowPath" className="spin" />
              ) : (
                <Icon name="ChevronRight" />
              )}
            </button>
          </div>

          <div className="tracking-parms">
            <h3>Tracking Paramaters</h3>
            <span>{"{aff_click_id} - Custom Tracking Value."}</span>
            <span>{"{sub_aff_id} - Custom Tracking Value."}</span>
            <span>{"{goal} - Goal of campaign."}</span>
            <span>{"{ip} - IP from which tracking link get clicked."}</span>
            <span>
              {
                "{user_agent} - User Agent from which tracking link get clicked."
              }
            </span>
            <span>Check global postback page to know more paramaters.</span>
          </div>
        </div>

        <div
          className={`postback-viewer ${isPostbackViewerActive ? "active" : ""
            }`}
        >
          <div className="top">
            <h3>Postback URL</h3>
            <p>
              This the URL currently set to be hit on conversion in{" "}
              {toViewPBInfo.goalName} goal.
            </p>
          </div>

          <span className="url-container">{toViewPBInfo.URL}</span>

          <div className="bottom">
            <button
              onClick={handelPostbackDeleteBtn}
              disabled={isDeletingPostback}
            >
              {isDeletingPostback ? (
                <Icon name="ArrowPath" className="spin" />
              ) : (
                <Icon name="Trash" />
              )}
              {isDeletingPostback ? "Deleting" : "Delete"}
            </button>
            <button
              onClick={handelPostbackViewerCloseClick}
              disabled={isDeletingPostback}
            >
              <Icon name="XMark" /> Close
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CampaignDetailPage;
